module.exports = __webpack_public_path__ + "fonts/fa-solid-900.b6a14bb8.ttf";